import { type ChangeEvent } from "react";
import { useFormAPI, useFormStore } from "@/widgets/classic-form/form";
import { LimitedValuesField } from "@/features/form-fields/basic-fields/LimitedValuesField";
import type { CollectionFocusAttributes } from "@/entities/form-metadata";
import { FOCUS_NAME_TO_LOCATIONS } from "@/entities/form-metadata";
import { Grid } from "@/shared/components/Grid";
import { useCSSSafeId } from "@/shared/hooks/useCSSSafeId";

export const CollectionFocus = ({ limitedValues, label }: CollectionFocusAttributes) => {
    const id = useCSSSafeId();
    const formAPI = useFormAPI();
    const priority = useFormStore(({ values }) => values.priority ?? "");

    const handleChange = (e: ChangeEvent<HTMLSelectElement>) => {
        const value = e.target.value;
        formAPI.setFieldValue("priority", value);
        formAPI.setFieldValue("location", FOCUS_NAME_TO_LOCATIONS[value] ?? []);
    };

    return (
        <Grid.Container>
            <Grid.Field spanDesktop={4} spanTablet={6} spanMobile={12}>
                <label htmlFor={id}>{label}</label>
                <LimitedValuesField
                    id={id}
                    ariaLabel={label}
                    value={priority}
                    onChange={handleChange}
                    limitedValues={limitedValues}
                />
            </Grid.Field>
        </Grid.Container>
    );
};
